<template>
  <div class="card-carousel">
    <div
      v-if="carouselTitle"
      class="card-carousel-title floating-box truncate max-w-[80%] font-medium"
    >
      {{ carouselTitle }}
      <md-tooltip md-direction="top">{{ carouselTitle }}</md-tooltip>
    </div>
    <img
      v-else-if="avatar"
      :src="avatar"
      alt="Avatar"
      class="floating-box h-[85px] w-[85px] object-cover"
    />
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "card-carousel",
  props: ["carouselTitle", "avatar"]
};
</script>

<style lang="scss" scoped>
.card-carousel {
  background: rgba(255, 255, 255, 0.93);
  padding: 50px 10px 10px;
  margin-top: 70px;
  margin-bottom: 30px;
  border-radius: 25px;
  border: 1px solid #cec1ff;
  width: 100%;
  position: relative;

  .floating-box {
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 3px 7px -1px rgba(0, 0, 0, 0.25);
  }

  &-title {
    background-color: #cec1ff;
    color: #554ce1;
    padding: 15px;
  }
}
</style>
